import React, { useState } from 'react';
import { InputAdornment, InputBase, Checkbox } from '@mui/material';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

import StyledCardNoHeight from '../../../components/card/StyledCardNoHeight';
import Iconify from '../../../components/iconify';

export default function ChurchSearchBar({ setQuery, setType }) {
  const [types, setTypes] = useState([]);

  const handleType = (type) => {
    if (types.includes(type)) {
      const reducedType = types.filter((item) => item !== type);
      setTypes(reducedType);
      setType([...new Set([...reducedType])]);
    } else {
      setTypes((prevTypes) => [...prevTypes, type]);
      setType([...new Set([...types, type])]);
    }
  };

  return (
    <>
      <StyledCardNoHeight
        sx={{
          display: { xs: 'flex', sm: 'none' },
          alignItems: 'normal',
          gap: 2,
          boxShadow: 5,
          borderRadius: 2,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        }}
      >
        <Typography>
          <Checkbox onClick={() => handleType('ገዳም')} /> ገዳም
          <Checkbox onClick={() => handleType('አጥቢያ')} /> አጥቢያ
          <Checkbox onClick={() => handleType('ካቴድራል')} /> ካቴድራል
        </Typography>{' '}
      </StyledCardNoHeight>
      <StyledCardNoHeight
        sx={{
          display: 'flex',
          alignItems: 'normal',
          gap: 2,
          mb: 4,
          boxShadow: 5,
          borderRadius: 2,
          borderTopLeftRadius: { xs: 0, md: 2 },
          borderTopRightRadius: { xs: 0, md: 2 },
        }}
      >
        <InputBase
          sx={{ flex: 1, minWidth: 150, ml: 5, mr: 2 }}
          placeholder="ፈልግ..."
          inputProps={{ 'aria-label': 'ፈልግ...' }}
          onChange={(e) => setQuery(e.target.value)}
          startAdornment={
            <InputAdornment position="start">
              <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
            </InputAdornment>
          }
        />
        <Typography sx={{ display: { xs: 'none', sm: 'block' }, mr: 2 }}>
          <Checkbox onClick={() => handleType('ገዳም')} /> ገዳም
          <Checkbox onClick={() => handleType('አጥቢያ')} /> አጥቢያ
          <Checkbox onClick={() => handleType('ካቴድራል')} /> ካቴድራል
        </Typography>
      </StyledCardNoHeight>
    </>
  );
}

ChurchSearchBar.propTypes = {
  setQuery: PropTypes.func,
  setType: PropTypes.func,
};
